/* eslint-disable max-classes-per-file */

import { RequestListProductTypeEnums } from "@/types/product/account/history";

import { ResponsePresenter } from "../../common/commonClassPresenter";
import {
  DayPlanDataPresenter,
  ListStepDataPresenter,
  RePaymentPresenter,
} from "./historyBookingCommonInterface";

export class AirportData {
  code: string;

  airportName: string;

  cityName: string;

  flightNumber: string;

  constructor(response: any) {
    this.code = response?.code || "";
    this.airportName = response?.airportName || "";
    this.cityName = response?.cityName || "";
    this.flightNumber = response?.flightNumber || "";
  }
}

class AirlineData {
  image: string;

  code: string;

  name: string;

  constructor(response: any) {
    this.image = response?.image || "";
    this.code = response?.code || "";
    this.name = response?.name || "";
  }
}

export class FlightSubDataPresenter {
  imageCover: string;

  dateOri: string;

  date: string;

  time: string;

  airport: AirportData;

  airline: AirlineData;

  constructor(response: any) {
    this.imageCover = response?.imageCover || "";
    this.dateOri = response?.dateOri || "";
    this.date = response?.date || "";
    this.time = response?.time || "";
    this.airport = new AirportData(response?.airport);
    this.airline = new AirlineData(response?.airline);
  }
}

export class FlightDataPresenter {
  duration: string;

  travelTimeMinutes: number;

  flightStop: number;

  dayPlan: DayPlanDataPresenter;

  departure: FlightSubDataPresenter;

  arrival: FlightSubDataPresenter;

  constructor(response: any) {
    this.duration = response?.duration || "";
    this.travelTimeMinutes = response?.travelTimeMinutes || 0;
    this.flightStop = response?.flightStop || 0;
    this.dayPlan = new DayPlanDataPresenter(response?.dayPlan);
    this.departure = new FlightSubDataPresenter(response?.departure);
    this.arrival = new FlightSubDataPresenter(response?.arrival);
  }
}

export class FlightDetailDataPresenter {
  departure: FlightDataPresenter;

  return: FlightDataPresenter;

  constructor(response: any) {
    this.departure = new FlightDataPresenter(response?.departure);
    this.return = new FlightDataPresenter(response?.return);
  }
}

export class FlightListDataPresenter {
  bookingInternalNo: string;

  pinCode: string;

  typeOfTrip: string;

  bookingDateOri: string;

  bookingDate: string;

  departureDateOri: string;

  departureDate: string;

  isWaitToPay: boolean;

  bookingStatus: string;

  paymentStatus: string;

  currency: string;

  price: number;

  cover: string;

  passengers: {
    name: string;
    count: number;
  };

  payment: RePaymentPresenter;

  data: FlightDetailDataPresenter;

  dateCancelOri: string;

  productType: string;

  dateCancel: string;

  cabinClass: string;

  constructor(response: any) {
    this.bookingInternalNo = response?.bookingInternalNo || "";
    this.pinCode = response?.pinCode || "";
    this.typeOfTrip = (response?.typeOfTrip || "").toLocaleLowerCase();
    this.bookingDateOri = response?.bookingDateOri || "";
    this.bookingDate = response?.bookingDate || "";
    this.departureDateOri = response?.departureDateOri || "";
    this.departureDate = response?.departureDate || "";
    this.isWaitToPay = response?.isWaitToPay || false;
    this.bookingStatus = (response?.bookingStatus || "").toLocaleLowerCase();
    this.paymentStatus = (response?.paymentStatus || "").toLocaleLowerCase();
    this.currency = response?.currency || "";
    this.price = response?.price || 0;
    this.cover = response?.cover || "";
    this.passengers = {
      name: response?.passengers?.name || "",
      count: response?.passengers?.count || 0,
    };
    this.payment = new RePaymentPresenter(response?.payment);
    this.data = new FlightDetailDataPresenter(response?.data);
    this.dateCancelOri = response?.dateCancelOri || "";
    this.productType = RequestListProductTypeEnums.FLIGHT;
    this.dateCancel = response?.dateCancel || "";
    this.cabinClass = response?.cabinClass || "";
  }
}

export class FlightListStepData extends ListStepDataPresenter<
  FlightListDataPresenter[]
> {
  constructor(response: any) {
    super(response, (data) =>
      (data || []).map((val: any) => new FlightListDataPresenter(val)),
    );
  }
}
export class ResponseGetHistoryFlightListPresenter extends ResponsePresenter<
  FlightListStepData[]
> {
  constructor(response: any) {
    super(response, (data) =>
      (data || []).map((val: any) => new FlightListStepData(val)),
    );
  }
}
